import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/opt/webrtc/node_modules/react-hot-toast/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/opt/webrtc/styles/globals.css");
;
import(/* webpackMode: "eager" */ "/opt/webrtc/node_modules/@livekit/components-styles/dist/general/index.css");
;
import(/* webpackMode: "eager" */ "/opt/webrtc/node_modules/@livekit/components-styles/dist/general/prefabs/index.css");
